module.exports = __webpack_public_path__ + "static/hospital_support_top_bg@2x-ce2ee8423e2e9743e795b35922b5b4f4.png";